export class AuthResponse{
    status = true;
    message = "";
    error = "";
    payload: any;
    date: Date;
    constructor(){
        this.date = new Date();
    }
    
}